export const cartSelector = (state) => state.cart;
